import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import WidgetContainer from '../Charts/widgetContainer/WidgetContainer.vue';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { dateRangeToDateStrings } from '@/utils/dates';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { ImportantMessageLevel } from '@/models/Charts/chartsData';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import { LayoutSlot } from '@/views/dashboard/layout-grid';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CuttingHead',
  props: {
    dateRange: null,
    deviceId: null,
    timeAxisSpan: null
  },
  setup(__props: any) {

const props = __props as {
  dateRange: [Date, Date];
  deviceId: string;
  timeAxisSpan: FilterTimeAxisSpanEnum;
};



const gridLayout: LayoutSlot[] = [
  { column: 0, row: 0, width: 8, height: 8 },
  { column: 8, row: 0, width: 4, height: 4 },
  { column: 8, row: 4, width: 4, height: 4 },
];

const diodesAndDrawerCyclesTimelineWidgetDefinition =
  computed<WidgetDefinition>(() =>
    new WidgetDefinition(
      WidgetEnum.CareCuttingHeadDiodesAndDrawerCyclesTimeline,
      props.deviceId,
      dateRangeToDateStrings(props.dateRange),
      [],
      undefined,
      props.timeAxisSpan,
    ).hideTitle(),
  );

const eventsTimelineWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.CareCuttingHeadEventsTimeline,
      props.deviceId,
      dateRangeToDateStrings(props.dateRange),
      [],
      undefined,
      props.timeAxisSpan,
      undefined,
      {
        eventTypes: [ImportantMessageLevel.Error],
        eventModules: ['Cutting Head'],
      },
    ),
);

const temperaturesWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.CareCuttingHeadTemperatures,
      props.deviceId,
      dateRangeToDateStrings(props.dateRange),
      [],
      undefined,
      props.timeAxisSpan,
    ),
);

const widgetDefinitions = computed<WidgetDefinition[]>(() =>
  [
    diodesAndDrawerCyclesTimelineWidgetDefinition.value,
    eventsTimelineWidgetDefinition.value,
    temperaturesWidgetDefinition.value,
  ].map((widget, index) => widget.withIndex(index)),
);

return { __sfc: true,props, gridLayout, diodesAndDrawerCyclesTimelineWidgetDefinition, eventsTimelineWidgetDefinition, temperaturesWidgetDefinition, widgetDefinitions, WidgetContainer, LayoutGrid }
}

})